class SubTask {
    constructor() {
    }

    static fromRaw(raw) {
        let subTask = new SubTask();
        subTask.raw = raw;
        subTask.uuid = raw.uuid;
        subTask.name = raw.name;
        subTask.status = raw.status;
        subTask.taskExitMessage = raw.taskExitMessage;
        subTask.startTime = raw.startTime;
        subTask.createdTime = raw.createdTime;
        subTask.finishTime = raw.finishTime;
        subTask.progress = raw.progress;
        return subTask;
    }

    toRaw() {
        return {
            uuid: this.uuid,
            name: this.name,
            status: this.status,
            taskExitMessage: this.taskExitMessage,
            startTime: this.startTime,
            createdTime: this.createdTime,
            finishTime: this.finishTime,
            progress: this.progress
        }
    }
}

module.exports = SubTask;



// WEBPACK FOOTER //
// ./src/azurebackup/model/SubTask.js